import { Pipe, PipeTransform } from '@angular/core';
import { CustomerDto } from '@careapp-group/ng-sdk-v2-new';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinct, map } from 'rxjs/operators';
import { requestDownloadUrl } from '../../store';
import { getUrls } from '../../store/files/files-selectors';

@Pipe({
  name: 'avatars',
  pure: true,
})
export class AvatarsPipe implements PipeTransform {
  constructor(private store: Store<any>) {}
  public transform(data: Array<CustomerDto>): Observable<{ fullName: string; image: string }[]> {
    if (!data) {
      return null;
    }

    // only dispatch for the top customer
    const customer = data[0];
    let variant = customer?.profileImage?.variants?.find((v) => v.purpose === 'sizeTiny');
    if (!variant) {
      variant = customer?.profileImage;
    }
    if (!!variant) {
      this.store.dispatch(requestDownloadUrl({ id: variant.id }));
    }

    return this.store.select(getUrls).pipe(
      map((urls) => {
        return data.map((customer) => {
          let variant = customer?.profileImage?.variants?.find((v) => v.purpose === 'sizeTiny');
          if (!variant) {
            variant = customer?.profileImage;
          }

          return {
            fullName: customer ? `${customer.firstName} ${customer.lastName}` : '',
            image: variant ? urls[variant.id]?.url : '',
          };
        });
      }),
      distinct()
    );
  }
}
